import { render, staticRenderFns } from "./SchoolDetails.vue?vue&type=template&id=71df22e6"
import script from "./SchoolDetails.vue?vue&type=script&lang=js"
export * from "./SchoolDetails.vue?vue&type=script&lang=js"
import style0 from "./SchoolDetails.vue?vue&type=style&index=0&id=71df22e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports